import axios from 'axios'
import { getScheduleValidation } from '../../config/config'

export default async function scheduleValidation(branchId) {
    return await axios.post(getScheduleValidation,
        {
            branchId: branchId,
        })

}